import { _hasProperty, ServiceModuleValue } from '@aw/lib'
import { ServiceModules } from '../constants/services'

export const rewrites: Record<string, string> = {
    '/sanctum/csrf-cookie': '/sanctum/csrf-cookie',
    '/login': '/login',
    '/login-with-google': '/login-with-google',
    '/signup-with-google': '/signup-with-google',
    '/register': '/register',
    '/forgot-password': '/forgot-password',
    '/reset-password': '/reset-password',
    '/email/verification-resend': '/email/verification-resend',
    '/email/verification-notification': '/email/verification-notification',

    '/has-twofactor-challenged': '/has-twofactor-challenged',
    '/two-factor-challenge': '/two-factor-challenge',

    '/user/confirmed-password-status': '/user/confirmed-password-status',
    '/user/confirm-password': '/user/confirm-password',

    '/user/two-factor-authentication': '/user/two-factor-authentication',
    '/user/confirmed-two-factor-authentication': '/user/confirmed-two-factor-authentication',
    '/user/two-factor-qr-code': '/user/two-factor-qr-code',
    '/user/two-factor-secret-key': '/user/two-factor-secret-key',
    '/user/two-factor-recovery-codes': '/user/two-factor-recovery-codes',
    "/up": "/up"
}


const resolve = ({ url, service }: {
    url: string,
    service: ServiceModuleValue
}) => {

    const API_SUFFIX = process.env.NEXT_PUBLIC_BACKEND_API_URL_SUFFIX
    if (_hasProperty(rewrites, url)) {
        return rewrites[url]
    }

    if (service === ServiceModules.AUTH || !service) {
        return API_SUFFIX + url
    }
    if (service === ServiceModules.TALENT_POOL_ATS) {
        return url
    }
    // subscription-service is its own host and ships full `/api/v1/...` paths,
    // so it takes neither the service prefix nor the shared API suffix.
    if (service === ServiceModules.SUBSCRIPTION) {
        return url
    }
    return service + API_SUFFIX + url
}

export default resolve
